import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';

const Confirm = ({ onCancel, onConfirm }) => (
	<Stack
		spacing={3}
		sx={{
			alignItems: 'center',
		}}
	>
		<Typography variant="h4" color="primary.main">
			{getLabelMessage('contactDetail:feedBackConfirmHeader')}
		</Typography>
		<Grid container sx={{ width: '100%' }}>
			<Grid size={12}>
				<Grid
					container
					spacing={3}
					sx={{
						justifyContent: 'center',
					}}
				>
					<Grid size={3}>
						<Button variant="outlined" onClick={onCancel} fullWidth>
							{getLabelMessage('common:no')}
						</Button>
					</Grid>
					<Grid size={3}>
						<Button variant="contained" onClick={onConfirm} fullWidth>
							{getLabelMessage('common:yes')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	</Stack>
);

Confirm.propTypes = {
	mui: PropTypes.bool,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
};

export default Confirm;
